import { render, staticRenderFns } from "./LandingChristmasFR.vue?vue&type=template&id=41373bc6&scoped=true"
import script from "./LandingChristmasFR.vue?vue&type=script&lang=js"
export * from "./LandingChristmasFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41373bc6",
  null
  
)

export default component.exports